<template>
  <div class="uni-detail__wrp">
    <subpage-header :city-icon="cityDetails ? cityDetails.icon : null">
 <div slot="bread">
<ul itemscope itemtype="http://schema.org/BreadcrumbList">
<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name"></span>holywoodskyline.com<span class="mytitle"> / </span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="city_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">{{ cityDetails.name }} Movies</span>
</a>
<meta itemprop="position" content="2" />
</li>
</ul>
</div>
      <span slot="title" v-if="cityDetails">
        <span class="color-light-green">{{ cityDetails.name }} </span> About
      </span>
      <div class="city-text" slot="text">
        <span v-if="cityDetails" v-html="cityDetails.detail_spot"></span>
      </div>
      <div class="subpage-header-inf" slot="numbers">
        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-uni.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="cityDetails">{{ cityDetails.universities_count }}</strong>
            <span>Üniversite</span>
          </div>
        </div>

        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="cityDetails">{{ cityDetails.dorms_count }}</strong>
            <span>Aktif Yurt</span>
          </div>
        </div>
      </div>
      <v-link
        v-if="cityDetails"
        class="button--more color-white subpage-header__btn"
        :title="`${cityDetails.name} Movie`"
        icon="icon-arrow-long-right"
        icon-position="right"
        :to="{ name: 'City', params: { id: cityDetails.id, slug: cityDetails.slug }}"
        slot="button"
      />
    </subpage-header>
    <div class="subpage__inner uni-detail__inner">
      <SubpageNav :links="links" class="DesktopTab"/>

      <div class="mobileTab">
        <!-- <select-box :options="linkMobile" title="Hakkında"/> -->
        <v-select placeholder="Hakkında" :options="linkMobile" @onselect="selectCategory"/>        
      </div>

      <transition name="fade-up">
        <router-view />
      </transition>

    </div>
  </div>
</template>

<script>
import SubpageHeader from '@/components/SubpageHeader'
import SubpageNav from '@/components/SubpageNav'
import SelectBox from '@/components/SelectBox'
import axios from 'axios'
import { mapGetters } from 'vuex'
import {
  GET_CITY_DETAILS
} from '@/store/actions.type'

export default {
  name: 'CityDetail',
  components: {
    SubpageHeader, SubpageNav, SelectBox
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.cityDetails ? this.cityDetails.detail_title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.cityDetails ? this.cityDetails.detail_description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.cityDetails ? this.cityDetails.detail_keywords : '' }
      ],
      link: [
        { rel: 'canonical', href: this.url }
      ]
    }
  },
  data () {
    return {
      url: '',
      city_url: '',
      selectedTab: {
        name: 'Hakkında',
        slug: '/hakkinda'
      },
      links: [
        {
          id: 0,
          title: 'Hakkında',
          to: { name: 'CityDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.city } }
        },
        {
          id: 1,
          title: 'İlçeler',
          to: { name: 'CityDetailDistrict' }
        },
        {
          id: 2,
          title: 'Üniversiteler',
          to: { name: 'CityDetailUnivercities' }
        }
      ],
      linkMobile: [
        {
          name: 'Hakkında'
        },
        {
          name: 'İlçeler'
        },
        {
          name: 'Üniversiteler'
        }
      ],
      details: null
    }
  },
  methods: {
    selectCategory(opt) {
      let slug = this.$route.params.city.split('/')      
      if(opt.name === 'İlçeler') {
        this.$router.push('/' + slug[0] + '-sehri-hakkinda/ilceler')
      } else if(opt.name === 'Üniversiteler') {
        this.$router.push('/' + slug[0] + '-sehri-hakkinda/universiteler')
      } else {
          this.$router.push('/' + slug[0] + '-sehri-hakkinda')
      }
      
    },    
    checkTab () {
      let slug = this.$route.params.city.split('/')
      if(this.$route.path.includes('ilceler')) {
        this.selectedTab.name = 'İlçeler'
        this.selectedTab.slug = slug[0] + slug [1] + '/ilceler'
      } else if(this.$route.path.includes('universiteler')) {
        this.selectedTab.name = 'Üniversiteler'
        this.selectedTab.slug = slug[0] + slug [1] + '/universiteler'
      } else {
        this.selectedTab.name = 'Hakkında'
        this.selectedTab.slug = slug[0] + slug [1] + '/fakulteler'
      }
    },
    toggle (index) {
      this.accordions[index].active = !this.accordions[index].active
    },
    checkCityDetails () {
      const slug = this.$route.params.city
      if (this.cityDetails) {
        if (this.cityDetails.slug !== slug) {
          this.$store.dispatch(GET_CITY_DETAILS, null)
          this.getCityDetails()
        }
      } else {
        this.getCityDetails()
      }
    },
    getCityDetails () {
      // const type = this.$route.params.typeID ? this.$route.params.typeID : ''
      let self = this
      axios.get(`/site/cities/${this.$route.params.city}`)
        .then(response => {
          this.$store.dispatch(GET_CITY_DETAILS, response.data)
          self.city_url = 'https://www.holywood.com/' + response.data.slug + '-movies/'
          // self.city_url = window.location.origin + '/' +
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['cityDetails'])
  },
  beforeDestroy () {
    // this.$store.dispatch(GET_CITY_DETAILS, null)
  },
  created () {
    this.checkCityDetails()
    this.url = window.location.origin + this.$route.fullPath
  },
  watch: {
    $route () {
      this.checkTab()
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/components/uni-detail";
  .mytitle1 {
    font-size: 15px;
    color:white;
  }
</style>
